import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { ChatChannel } from '@app/model/chat-channel';
import { SendbirdService } from '@app/services/sendbird.service';
import { Subject } from 'rxjs';
import { ChatChannelMessagesListComponent } from '../chat-channel-messages-list/chat-channel-messages-list.component';
import { ChatMessageInputComponent } from '../chat-message-input/chat-message-input.component';

@Component({
    selector: 'app-chat-channel',
    templateUrl: './chat-channel.component.html',
    styleUrls: ['./chat-channel.component.scss'],
    standalone: false
})
export class ChatChannelComponent implements OnDestroy {
  @ViewChild(ChatMessageInputComponent) public chatInput: ChatMessageInputComponent;
  @ViewChild(ChatChannelMessagesListComponent) public messagesList: ChatChannelMessagesListComponent;

  @Input() public disabled = false;
  @Input() public set channelUrl(value: string) {
    if (!value) {
      return;
    }

    this.sendbirdService.getChannelByUrl(value).subscribe(data => this.groupChannel = data);
  }

  @Input() public hideBorder = true;
  @Input() public groupChannel: ChatChannel;

  private readonly unsubscribe: Subject<void> = new Subject();

  constructor(private readonly sendbirdService: SendbirdService) { }

  public restoreScrollPosition(): void {
    this.messagesList?.scrollUpdated();
  }

  public markAsRead(): void {
    if (this.disabled) {
      return;
    }

    this.sendbirdService.markChannelAsRead(this.groupChannel);
  }

  public editMessage(item: SendBird.UserMessage): void {
    this.chatInput.setEditMessage(item);
  }

  public updateMessage(context: { message: string; reference: SendBird.UserMessage }): void {
    this.sendbirdService.updateMessage(this.groupChannel, context.reference, context.message);
  }

  public sendMessage(message: string): void {
    this.sendbirdService.sendMessage(this.groupChannel, message);
  }


  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
